import { IState } from '../store';

export function selectIsTestMode(state: IState): boolean {
  return state.isQaMode;
}
